import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { map, takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { HttpClient } from '@angular/common/http';
import { PaymentService } from '../payment.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';

import {
	URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP,
	URL_PAYMENT_PAYPAL_CREATE_ORDER_NORMAL,
	URL_PAYMENT_PAYPAL_CAPTURE_ORDER_NORMAL,
	URL_PAYMENT_PAYPAL_CREATE_ORDER_OCP,
	PAYMENT_METHOD_PAYPAL,
	PAYPAL_PAYMENT_RESULT,
	PAYPAL_CLIENT_ID,
	DISCOUNT_STATUS_ACTIVE
} from '@ibe.config';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';


declare let paypal: any;

@Component({
	selector: 'app-paypal-payment',
	templateUrl: './paypal-payment.component.html',
	styleUrls: ['./paypal-payment.component.scss']
})



export class INDRAPaypalPaymentComponent implements OnInit, OnDestroy {
	@Output() emitLoader = new EventEmitter<boolean>();
	@Output() emitVoucherError = new EventEmitter<any>();
	@Input() promoCodesAndVoucher: Array<any>;

	isAlive = true;
	userInfo$: Observable<Object> = this.store.select(fromStore.getUserInfo);
	isLoggedIn: boolean = false;
	selectedPaymentMethod;
	savePaypalChecked: boolean = false;
	airlineID;
	points;
	cashPrice;
	totalFlightPrice;
	currency;
	idOperation; // idOperation will only be used on create-accept/approve API calls, and will not be reused on subsequent payment tries using other payment methods
	formIsValid: boolean = false;
	timer;
	captureOCPResponse;
	captureNormalResponse;

	isCaptureOrderOcpLoading: boolean = false;
	redeemVoucherAPICallFlag: boolean = true;


	constructor(
		private store: Store<fromStore.State>,
		private storage: INDRAStorageService,
		private http: HttpClient,
		private paymentService: PaymentService,
		private flightPriceService: INDRAFlightPriceService,
		private currencyService: INDRACurrencyService,
		private indraPaymentService: INDRAPaymentService,
	) {
		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((user: any) => {
				if (user) {
					this.isLoggedIn = true;
				}
			});

		this.paymentService.selectedMethod
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(selectedPaymentMethod => {
				if (selectedPaymentMethod) {
					this.selectedPaymentMethod = selectedPaymentMethod;
				}
			});

		this.paymentService.formIsValid
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(formIsValid => {
				if (formIsValid != undefined) {
					this.formIsValid = formIsValid;
				}
			});

		this.paymentService.savePaypalData
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(isSave => {
				if (isSave) {
					this.savePaypalChecked = isSave;
				} else {
					this.savePaypalChecked = isSave;
				}
			});

	}

	ngOnInit() {
		// this.INDRA_loadPaypalScripts();
		this.INDRA_initializeButtons();
	}

	INDRA_convertToCorrectDecimalPlace(cashPrice) {
		const decimalPlace = this.currencyService.INDRA_getDecimalPlaces();
		const cashPriceStr = decimalPlace > 0 ? cashPrice.toFixed(2) : this.flightPriceService.INDRA_convertToCorrectDecimalPlace(cashPrice.toString());
		return cashPriceStr;
	}

	INDRA_redeemVoucher() {
		if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
			let redeemVoucherSuccessFlag: boolean;
			let redeemVoucherResults: any = [];
			if (this.redeemVoucherAPICallFlag) {
				this.redeemVoucherAPICallFlag = false;
				this.indraPaymentService.INDRA_redeemVoucher()
					.pipe(takeWhile(() => this.isAlive))
					.subscribe(response => {
						this.redeemVoucherAPICallFlag = true;

						if (response && response.status == '200') {
							if (response.data) {
								const vouchers = response.data.vouchers;
								if (vouchers && vouchers.length > 0) {
									vouchers.map(data => {
										if (data.status === 'KO') {
											redeemVoucherResults.push(data);
										}
									});

									if (redeemVoucherResults && redeemVoucherResults.length > 0) {
										//CASE: THERE IS AN ERROR WITH ONE OF THE VOUCHERS
										//METHOD: DISPLAY THE WARNING MESSAGE TO THE PAYMENT PAGE REGARDING THE VOUCHER ISSUE
										redeemVoucherSuccessFlag = false;
									} else {
										//CASE: ALL VOUCHERS ARE OK
										redeemVoucherSuccessFlag = true;
									}
								} else {
									//CASE: THERE ARE NO VOUCHERS
									redeemVoucherSuccessFlag = true;
								}
							} else {
								redeemVoucherSuccessFlag = true;
							}
						} else {
							//CASE: RESPONSE HAS ERROR STATUS
							redeemVoucherSuccessFlag = false;
						}

						if (redeemVoucherSuccessFlag) {
							//CASE: PROCEED WITH THE INITIALIZATION OF PAYPAL BUTTON & POP-UP MODAL
							this.emitVoucherError.emit(null);
							if (this.savePaypalChecked) {
								this.INDRA_proceedInitializeBlueButton();
							} else {
								this.INDRA_proceedInitializeGoldButton();
							}
						} else {
							if (this.savePaypalChecked) {
								paypal.Buttons({
									onInit: function (data, actions) {
										//METHOD: DISABLE THE BUTTON FROM OPENING THE PAYPAL POP-UP MODAL
										actions.disable();
									},
									style: {
										layout: 'horizontal',
										size: 'large',
										color: 'blue',
										shape: 'rect',
										label: 'pay',
										tagline: false
									},
									onClick: async (data, actions) => {
										this.emitLoader.emit(false);
										this.emitVoucherError.emit(redeemVoucherResults);
									}

								}).render('#paypal-blue-button-indra');
							} else {
								paypal.Buttons({
									onInit: function (data, actions) {
										//METHOD: DISABLE THE BUTTON FROM OPENING THE PAYPAL POP-UP MODAL
										actions.disable();
									},
									style: {
										layout: 'horizontal', // horizontal | vertical
										size: 'large', // small | medium | large | responsive
										color: 'gold', // gold | blue | silver | white | black
										shape: 'rect', // pill | rect
										label: 'pay', //  checkout | paypal | pay | buynow
										tagline: false
									},
									onClick: async (data, actions) => {
										this.emitLoader.emit(false);
										this.emitVoucherError.emit(redeemVoucherResults);
									}

								}).render('#paypal-gold-button-indra');

							}
						}
					}, (err) => {
						this.redeemVoucherAPICallFlag = true;
						//CASE: ERROR WITH THE INDRA_redeemVoucher RESPONSE
						console.log('error', err);
						this.emitVoucherError.emit(redeemVoucherResults);
					});
			}
		} else {
			//CASE: PROCEED WITH THE INITIALIZATION OF PAYPAL BUTTON & POP-UP MODAL
			this.emitVoucherError.emit(null);
			if (this.savePaypalChecked) {
				this.INDRA_proceedInitializeBlueButton();
			} else {
				this.INDRA_proceedInitializeGoldButton();
			}

		}
	}

	INDRA_initializePaypalButtons() {
		this.INDRA_redeemVoucher();
	}

	INDRA_proceedInitializeGoldButton() {
		const userData = this.storage.get('userData');
		if (userData) {
			this.airlineID = userData.airlineID;
		}
		
		
		if (document.querySelector('#paypal-gold-button-indra').children.length > 0) {
        	return; // prevent double render
    	}

		paypal.Buttons({
			style: {
				layout: 'horizontal', // horizontal | vertical
				size: 'large', // small | medium | large | responsive
				color: 'gold', // gold | blue | silver | white | black
				shape: 'rect', // pill | rect
				label: 'pay', //  checkout | paypal | pay | buynow
				tagline: false
			},

			onClick: async (data, actions) => {
				this.emitLoader.emit(true);
			},

			// start of order flow
			createOrder: async () => {

				this.totalFlightPrice = this.paymentService.getTotalFlightPrice();
				this.cashPrice = this.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash);
				this.currency = this.totalFlightPrice.currency;
				this.points = this.totalFlightPrice.miles ? this.totalFlightPrice.miles : null;

				const createOrderParam = {
					deviceChannel: 'browser',
					sessionId: this.storage.get('token'),
					currency: this.currency,
					amount: +(this.cashPrice),
					pnr: this.storage.get('bookingPnr'),
					paymentMethodCode: PAYMENT_METHOD_PAYPAL,
					paymentMethod: 'paypal'
				};

				if (this.isLoggedIn) {
					if (this.points) {
						createOrderParam['points'] = this.points;
					}
					createOrderParam['flyTapId'] = this.airlineID;
				}

				const data = await this.http.post<any>(URL_PAYMENT_PAYPAL_CREATE_ORDER_NORMAL, createOrderParam).toPromise().catch(() => {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
				});

				// handle error message "Error PNR paid IBE", user is trying to pay again after
				// a failed PP payment attempt
				// prevent user from trying another payment attempt
				if (data && data.status === '400' && data.errors) {
					const error = data.errors;
					if (error && error.length && error.some(err => err.code === '34' &&
						err.desc === "Error PNR paid IBE")) {
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.PAID_ERROR);
						return;
					}
				}

				console.log(JSON.stringify(data));
				if (data && data.status !== '200') {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
				}

				this.storage.set('idPaypal', data.data.idPaypal);
				this.idOperation = data.data.idOperation;

				return data.data.idPaypal;
			},

			onApprove: async (data) => {

				const onApproveParam = {
					deviceChannel: 'browser',
					sessionId: this.storage.get('token'),
					currency: this.currency,
					amount: +(this.cashPrice),
					pnr: this.storage.get('bookingPnr'),
					paymentMethodCode: PAYMENT_METHOD_PAYPAL,
					paymentMethod: 'paypal',
					idOperation: this.idOperation,
					idPaypal: this.storage.get('idPaypal'),
					payerID: data.payerID,
					facilitatorAccessToken: data.facilitatorAccessToken,
				};

				if (this.isLoggedIn) {
					if (this.points) {
						onApproveParam['points'] = this.points;
					}
					onApproveParam['flyTapId'] = this.airlineID;
				}

				const onApproveRes = await this.http.post<any>(URL_PAYMENT_PAYPAL_CAPTURE_ORDER_NORMAL, onApproveParam).toPromise().catch(() => {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
				});

				if (onApproveRes) {
					console.log(JSON.stringify(onApproveRes));
					this.INDRA_handlePaypalReponse(onApproveRes);
				}
			},

			onError: function (err) {
				// Show an error page here, when an error occurs
				this.emitLoader.emit(false);
				this.idOperation = null;
				this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
			},
			onCancel: async (data) => {
				// Show a cancel page, or return to cart
				this.emitLoader.emit(false);
				this.idOperation = null;
			}
		}).render('#paypal-gold-button-indra');
	}


	INDRA_proceedInitializeBlueButton() {
		const userData = this.storage.get('userData');
		if (userData) {
			this.airlineID = userData.airlineID;
		}

		paypal.Buttons({
			style: {
				layout: 'horizontal',
				size: 'large',
				color: 'blue',
				shape: 'rect',
				label: 'pay',
				tagline: false
			},

			onClick: async (data, actions) => {
				this.emitLoader.emit(true);
			},

			// start of order flow
			createBillingAgreement: async () => {

				this.totalFlightPrice = this.paymentService.getTotalFlightPrice();
				this.cashPrice = this.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash);
				this.currency = this.totalFlightPrice.currency;
				this.points = this.totalFlightPrice.miles ? this.totalFlightPrice.miles : null;

				const createBillingAgreementBody = {
					deviceChannel: 'browser',
					sessionId: this.storage.get('token'),
					currency: this.currency,
					amount: +(this.cashPrice),
					pnr: this.storage.get('bookingPnr'),
					paymentMethodCode: PAYMENT_METHOD_PAYPAL,
					paymentMethod: 'paypal'
					// idOperation: this.storage.get('idOperation'),
				};

				if (this.isLoggedIn) {
					createBillingAgreementBody['flyTapId'] = this.airlineID;
					if (this.points) {
						createBillingAgreementBody['points'] = this.points;
					}
				}

				const data = await this.http.post<any>(URL_PAYMENT_PAYPAL_CREATE_ORDER_OCP, createBillingAgreementBody).toPromise().catch(() => {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
				});

				// handle error message "Error PNR paid IBE", user is trying to pay again after
				// a failed PP payment attempt
				// prevent user from trying another payment attempt
				if (data && data.status === '400' && data.errors) {
					const error = data.errors;
					if (error && error.length && error.some(err => err.code === '34' &&
						err.desc === "Error PNR paid IBE")) {
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.PAID_ERROR);
						return;
					}
				}

				console.log(JSON.stringify(data));
				if (data && data.status !== '200') {
					this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
				}
				this.storage.set('idPaypal', data.data.idPaypal);
				this.idOperation = data.data.idOperation;

				return data.data.idPaypal;
			},

			onApprove: async (data) => {
				const bodyOnApproveOcp = {
					deviceChannel: 'browser',
					sessionId: this.storage.get('token'),
					currency: this.currency,
					amount: +(this.cashPrice),
					pnr: this.storage.get('bookingPnr'),
					paymentMethodCode: PAYMENT_METHOD_PAYPAL,
					paymentMethod: 'paypal',
					idOperation: this.idOperation,
					storeOCP: 'true',
					idPaypal: data.billingToken,
					orderID: data.orderID,
					facilitatorAccessToken: data.facilitatorAccessToken
				};

				if (this.isLoggedIn) {
					bodyOnApproveOcp['flyTapId'] = this.airlineID;
					if (this.points) {
						bodyOnApproveOcp['points'] = this.points;
					}
				}

				// Prevent parallel calls of paypal/capture/order/ocp API in this callback method
				if (!this.isCaptureOrderOcpLoading) {
					this.isCaptureOrderOcpLoading = true;
					const blueOnApproveRes = await this.http.post<any>(URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP, bodyOnApproveOcp).toPromise().catch(() => {
						this.isCaptureOrderOcpLoading = false;
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
					});

					if (blueOnApproveRes) {
						this.isCaptureOrderOcpLoading = false;
						console.log(JSON.stringify(blueOnApproveRes));
						this.INDRA_handlePaypalReponse(blueOnApproveRes);
					}
				}
			},

			onError: function (err) {
				// Show an error page here, when an error occurs
				this.emitLoader.emit(false);
				this.idOperation = null;
				this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
			},
			onCancel: async (data) => {
				// Show a cancel page, or return to cart
				this.emitLoader.emit(false);
				this.idOperation = null;
			}

		}).render('#paypal-blue-button-indra');
	}


	INDRA_handlePaypalReponse(res) {
		if (res.status === '200' || res.status === '211') {
			if (res.data && res.data.statusBook) {
				switch (res.data.statusBook) {
					case 'ISSUE_OK':
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_OK);
						break;
					case 'ISSUE_KO':
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_KO);
						break;
					case 'ISSUE_ERROR':
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_ERROR);
						break;
					default:
						this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
						break;
				}
			} else if (res.data && res.data.resultFCE === 'REJECT') {
				this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.REJECTED);
			} else {
				this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
			}
		} else if (res.status == '300' || res.status == '301') {
			this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
		} else if (res.status === '400' && res.errors && res.errors.length && res.errors.some(err => err.code === '34' &&
			err.desc === "Error PNR paid IBE")) {
			this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.PAID_ERROR);
			return;
		} else {
			this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
		}

		/*
		if (res && res.data) {
			this.paymentService.setPaymentOperationID(res.data.idOperation);
			this.storage.set('idOperation', res.data.idOperation);
		}
		*/
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}

	/*
	INDRA_loadPaypalScripts(){

		var sdk = document.createElement('script');
		sdk.type = 'text/javascript';
		sdk.src = 'https://www.paypal.com/sdk/js?client-id='+ PAYPAL_CLIENT_ID + '&intent=capture&currency=EUR&commit=true&vault=true&components=buttons,funding-eligibility&debug=false';
		
		var paypalApi = document.createElement('script');
		paypalApi.setAttribute('data-version-4', '');
		paypalApi.setAttribute('async', '');
		paypalApi.type = 'text/javascript';
		paypalApi.src = 'https://www.paypalobjects.com/api/checkout.js';

		var paypalComponent = document.createElement('script');
		paypalComponent.setAttribute('async', '');
		paypalComponent.type = 'text/javascript';
		paypalComponent.src = 'https://js.braintreegateway.com/web/3.60.0/js/paypal-checkout.min.js';

		let paypalScript = document.querySelector(`script[src="${paypalComponent.src}"]`) ?  true : false;
		let apiScript = document.querySelector(`script[src="${paypalComponent.src}"]`) ?  true : false;
		let sdkScript = document.querySelector(`script[src="${sdk.src}"]`) ?  true : false;

		if(!paypalScript && !apiScript && !sdkScript){
			// Paypal SDK
			document.head.appendChild(sdk);
			// Load PayPal's checkout.js Library. 
			document.head.appendChild(paypalApi);
			// Load the PayPal Checkout component.
			document.head.appendChild(paypalComponent);
			this.INDRA_initializeButtons()
		} else if(paypalScript && apiScript && sdkScript){
			this.INDRA_initializeButtons()
		}
	}
	*/

	INDRA_initializeButtons() {
		this.timer = setInterval(() => {
			if (this.storage.get('bookingPnr') != null) {
				this.INDRA_initializePaypalButtons();
				clearInterval(this.timer);
			}
		}, 2000);
	}

}
